import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Chip,
  Divider,
  IconButton,
  LinearProgress,
  Tooltip,
  Typography
} from '@mui/material';
import {
  Close as CloseIcon,
  Pause as PauseIcon,
  PlayArrow as PlayIcon
} from '@mui/icons-material';

const TTS_RATES = [1, 1.25, 1.5];

const ArticleModalTtsControlBar = ({
  isActive,
  isPaused,
  progress,
  rate,
  onToggle,
  onChangeRate,
  onStop
}) => {
  if (!isActive) return null;

  return (
    <Box sx={{
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '42px',
      animate: 'fadeIn 0.2s ease-in-out'
    }}>
      <Typography variant="caption" sx={{
        fontWeight: 'bold',
        textTransform: 'uppercase',
        color: 'primary.main',
        whiteSpace: 'nowrap',
        display: { xs: 'none', sm: 'block' },
        letterSpacing: 1.5
      }}>
        Ouvindo Artigo
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 }, flex: { xs: 1, sm: 'none' }, justifyContent: 'flex-end', minWidth: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: { xs: 0, md: 220 }, flex: { xs: 1, md: 'none' } }}>
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              flex: 1,
              height: 4,
              borderRadius: 2,
              bgcolor: 'action.selected',
              '& .MuiLinearProgress-bar': { borderRadius: 2 }
            }}
          />
          <Typography variant="caption" sx={{ color: 'text.secondary', minWidth: 28, fontWeight: 700, fontSize: '0.7rem' }}>
            {Math.round(progress)}%
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
          <Tooltip title={isPaused ? 'Retomar' : 'Pausar'}>
            <IconButton size="small" onClick={onToggle} color="primary" sx={{ width: 42, height: 42 }}>
              {isPaused ? <PlayIcon sx={{ fontSize: '1.5rem' }} /> : <PauseIcon sx={{ fontSize: '1.5rem' }} />}
            </IconButton>
          </Tooltip>

          <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 0.5 }}>
            {TTS_RATES.map(value => (
              <Chip
                key={value}
                label={`${value}x`}
                size="small"
                onClick={() => onChangeRate(value)}
                variant={rate === value ? 'filled' : 'outlined'}
                color={rate === value ? 'primary' : 'default'}
                sx={{
                  height: 24,
                  fontSize: '0.6rem',
                  fontWeight: rate === value ? 700 : 400,
                  transition: 'all 0.2s',
                  minWidth: 32
                }}
              />
            ))}
          </Box>

          <Divider orientation="vertical" flexItem sx={{ mx: 0.5, height: 16, alignSelf: 'center', display: { xs: 'none', md: 'block' } }} />

          <Tooltip title="Encerrar Leitura">
            <IconButton
              size="small"
              onClick={onStop}
              sx={{
                width: 42,
                height: 42,
                color: 'text.secondary',
                '&:hover': { color: 'error.main', bgcolor: 'rgba(211, 47, 47, 0.04)' }
              }}
            >
              <CloseIcon sx={{ fontSize: '1.25rem' }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </Box>
  );
};

ArticleModalTtsControlBar.propTypes = {
  isActive: PropTypes.bool.isRequired,
  isPaused: PropTypes.bool.isRequired,
  progress: PropTypes.number.isRequired,
  rate: PropTypes.number.isRequired,
  onToggle: PropTypes.func.isRequired,
  onChangeRate: PropTypes.func.isRequired,
  onStop: PropTypes.func.isRequired
};

export default ArticleModalTtsControlBar;
